import React from 'react';

import PropTypes from 'prop-types';

import { Avatar } from '../../../../../../shared/components/Avatar';

import styles from './Message.module.scss';

const Message = ({ content, sender }) => (
  <div className={styles.message}>
    <div className={styles.message__avatar}>
      <Avatar avatarColor={sender.avatarColor} initials={sender.initials} />
    </div>

    <div className={styles.message__content}>
      <p>{content}</p>
    </div>
  </div>
);

Message.propTypes = {
  content: PropTypes.string.isRequired,
  sender: PropTypes.shape({
    avatarColor: PropTypes.string.isRequired,
    initials: PropTypes.string.isRequired,
  }).isRequired,
};

export default Message;
